module.exports = __webpack_public_path__ + "img/facebook_icon.61a96c78.png";